import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { Dynamic, type DynamicAction } from '@shared/registry/dynamic';

import { type LabResultCardConfig } from './lab-result-card.types';

@Component({
  selector: 'app-lab-result-card',
  templateUrl: './lab-result-card.html',
  imports: [Dynamic],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabResultCard {
  readonly config = input.required<LabResultCardConfig>();

  readonly action = output<DynamicAction | undefined>();

  protected readonly hasTitle = computed(() => !!this.config().title);
  protected readonly hasBorder = computed(() => this.config().hasBorder ?? false);

  protected readonly titleConfig = computed(() => ({
    text: this.config().title,
    size: 'xl' as const,
    fontWeight: 'semibold' as const,
    color: 'var(--labresultcard-title-color)',
    fontFamily: 'var(--labresultcard-font-family)',
  }));

  protected readonly primaryTextConfig = computed(() => ({
    text: this.config().primaryText,
    size: 'xl' as const,
    fontWeight: 'semibold' as const,
    color: 'var(--labresultcard-title-color)',
  }));

  protected readonly secondaryTextConfig = computed(() => ({
    text: this.config().secondaryText,
    size: 'sm' as const,
    fontWeight: 'bold' as const,
    color: 'var(--labresultcard-title-color)',
    fontFamily: 'var(--labresultcard-font-family)',
  }));

  protected readonly supportingTextConfig = computed(() => ({
    text: this.config().supportingText,
    size: 'sm' as const,
    fontWeight: 'bold' as const,
    color: 'var(--labresultcard-supporting-text-color)',
    fontFamily: 'var(--labresultcard-font-family)',
  }));

  protected readonly chipConfig = computed(() => this.config().chip);

  protected onTitleClick(): void {
    this.action.emit(this.config().action);
  }
}
